/** @jsx h */
import { Accordion } from '../../../../../shared/js/modules/accordion';
import { useRef, useEffect } from 'preact/hooks';
import FilterDate from './FilterDate';
import FilterZip from './FilterZip';
import { Fragment } from 'preact';
import { labels, searchType } from '../../config';
import FilterCheckbox from './FilterCheckbox';

const FilterContainer = ({
  facet,
  triggerAjaxSubmit,
  pluginNamespace,
  isMainSearch,
  isReset,
}) => {
  const accordionHandler = useRef(null);
  const accordionTarget = useRef(null);
  const accordionTargetInner = useRef(null);

  useEffect(() => {
    if (
      accordionHandler.current &&
      accordionTarget.current &&
      accordionTargetInner.current
    ) {
      const accordionInstance = new Accordion({
        target: accordionTarget.current,
        targetInner: accordionTargetInner.current,
        handler: accordionHandler.current,
        initOpened: !!(searchType === 'network'),
      });

      accordionInstance.init();
    }
  }, []);

  return (
    <Fragment>
      <legend className="filter__legend text">
        <button
          className="btn btn--icon filter__button"
          type="button"
          ref={accordionHandler}
        >
          <span>{facet.label}</span>
          <span className="sr-only">{labels.faceting.toggleFilters}</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="svg-plus"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path
              fill="currentColor"
              d="M 10.4,13.6 H 1.6 C 1.2,13.6 0.8,13.4 0.5,13.1 0.2,12.8 0,12.4 0,12 0,11.6 0.2,11.2 0.5,10.9 0.8,10.6 1.2,10.4 1.6,10.4 h 8.8 V 1.6 C 10.4,1.2 10.6,0.8 10.9,0.5 11.2,0.2 11.6,0 12,0 c 0.4,0 0.8,0.2 1.1,0.5 0.3,0.3 0.5,0.7 0.5,1.1 v 8.8 h 8.8 c 0.4,0 0.8,0.2 1.1,0.5 0.3,0.3 0.5,0.7 0.5,1.1 0,0.4 -0.2,0.8 -0.5,1.1 -0.3,0.3 -0.7,0.5 -1.1,0.5 h -8.8 v 8.8 c 0,0.4 -0.2,0.8 -0.5,1.1 -0.3,0.3 -0.7,0.5 -1.1,0.5 -0.4,0 -0.8,-0.2 -1.1,-0.5 -0.3,-0.3 -0.5,-0.7 -0.5,-1.1 0,0 0,-8.8 0,-8.8 z"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="svg-minus"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path
              fill="currentColor"
              d="M 1.6,13.6 C 1.2,13.6 0.8,13.4 0.5,13.1 0.2,12.8 0,12.4 0,12 0,11.6 0.2,11.2 0.5,10.9 0.8,10.6 1.2,10.4 1.6,10.4 h 20.7 c 0.4,0 0.8,0.2 1.1,0.5 0.3,0.3 0.5,0.7 0.5,1.1 0,0.4 -0.2,0.8 -0.5,1.1 -0.3,0.3 -0.7,0.5 -1.1,0.5 0,0 -20.7,0 -20.7,0 z"
            />
          </svg>
        </button>
      </legend>
      <div className="filter__options" ref={accordionTarget}>
        <div className="filter__options-inner" ref={accordionTargetInner}>
          {facet.type === 'dateRange' ? (
            <FilterDate
              facet={facet}
              triggerAjaxSubmit={triggerAjaxSubmit}
              pluginNamespace={pluginNamespace}
              isReset={isReset}
            />
          ) : facet.type === 'input' ? (
            <FilterZip
              facet={facet}
              triggerAjaxSubmit={triggerAjaxSubmit}
              pluginNamespace={pluginNamespace}
              isReset={isReset}
            />
          ) : facet.type === 'options' ? (
            <ul className="filter__list">
              {facet.options.map(option => (
                <li className="filter__item" key={option.value}>
                  <FilterCheckbox
                    option={option}
                    filterName={facet.name}
                    handleChange={triggerAjaxSubmit}
                    pluginNamespace={pluginNamespace}
                    isMainSearch={isMainSearch}
                  />
                </li>
              ))}
            </ul>
          ) : (
            ''
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default FilterContainer;
